/**
 * @ngdoc module
 * @name vrm.core
 * @description VRM core module
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(SettingsConfig);

    /**
     * @constructor
     * @ngInject
     */
    function SettingsConfig($stateProvider) {

        // set available routes
        $stateProvider
            .state('base.installation.settings.tags', {
                url: '/tags',
                views: {
                    "settings": {
                        template: require('@/angular/views/core/installation/settings/tags.html'),
                        controller: 'TagSettingsController'
                    }
                }
            });
    }

})();
